var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 0.890625V1.75H6.54688V0.890625V0.375H7.57812V0.890625V1.75H9.8125V3.46875V4.5V10.3438V11.375H8.78125H1.21875H0.1875V10.3438V4.5V3.46875V1.75H2.42188V0.890625V0.375H3.45312V0.890625ZM1.21875 4.5V10.3438H8.78125V4.5H1.21875ZM2.25 5.875H3.625V7.25H2.25V5.875ZM6.375 7.9375H7.75V9.3125H6.375V7.9375ZM4.3125 6.04688H7.75V7.07812H4.3125V6.04688ZM2.25 8.10938H5.6875V9.14062H2.25V8.10938Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.83ffe0152af4a1a96dfcc285f519d2cf.svg";
export { ForwardRef as ReactComponent };